import Flirt from './Flirt'

export default Flirt
